import { CommonEnums } from 'src/app/shared/common.enums';

export class Looper {
    looper_Id: number;
    dxFlow_Id: number;
    nm: string;
    paramNm: string;
    description: string;
    ver: string;
    itrType: string;
    itrVal: string;
    itrStart: number;
    itrEnd: number;
    itrIncrVal: number;
    itrValid_Cd: string;
    conn_Id: number;
    conn_Db_Id: number;
    itrDTyp_Id: number;
    iterationType: string;
    failFlag: string;
    valid_Cd: string;
    updateDt: Date;
    updateBy: string;
    agentGrpInd: string;
    flagent_Id: number;
    delim: string;
    flagentNm: string;
    disableFlg: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    parallelInstances: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.looper_Id = CommonEnums.defaults.LONG_VAL;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.paramNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.itrType = CommonEnums.defaults.STRING_EMPTY;
        this.itrVal = CommonEnums.defaults.STRING_EMPTY;
        this.itrStart = CommonEnums.defaults.LONG_VAL;
        this.itrEnd = CommonEnums.defaults.LONG_VAL;
        this.itrIncrVal = CommonEnums.defaults.LONG_VAL;
        this.itrValid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.itrDTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.iterationType = CommonEnums.defaults.STRING_EMPTY;
        this.failFlag = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.agentGrpInd = CommonEnums.defaults.STRING_EMPTY;
        this.flagent_Id = CommonEnums.defaults.LONG_VAL;
        this.delim = CommonEnums.defaults.STRING_EMPTY;
        this.flagentNm = CommonEnums.defaults.STRING_EMPTY;
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
        this.parallelInstances = CommonEnums.defaults.LONG_VAL;
    }

    getPrimaryKey(): string {
        return this.looper_Id + '.' + this.dxFlow_Id;
    }

    static parse(looperTmp: Looper): Looper {
        let looper: Looper = new Looper();
        looper.copyFrom(looperTmp as Looper);
        return looper;
    }

    copy(): Looper {
        let looperTmp: Looper = new Looper();

        looperTmp.looper_Id = this.looper_Id;
        looperTmp.dxFlow_Id = this.dxFlow_Id;
        looperTmp.nm = this.nm;
        looperTmp.paramNm = this.paramNm;
        looperTmp.description = this.description;
        looperTmp.ver = this.ver;
        looperTmp.itrType = this.itrType;
        looperTmp.itrVal = this.itrVal;
        looperTmp.itrStart = this.itrStart;
        looperTmp.itrEnd = this.itrEnd;
        looperTmp.itrIncrVal = this.itrIncrVal;
        looperTmp.itrValid_Cd = this.itrValid_Cd;
        looperTmp.conn_Id = this.conn_Id;
        looperTmp.conn_Db_Id = this.conn_Db_Id;
        looperTmp.itrDTyp_Id = this.itrDTyp_Id;
        looperTmp.iterationType = this.iterationType;
        looperTmp.retryEnabled = this.retryEnabled;
        looperTmp.failFlag = this.failFlag;
        looperTmp.valid_Cd = this.valid_Cd;
        looperTmp.updateDt = this.updateDt
        looperTmp.updateBy = this.updateBy;
        looperTmp.agentGrpInd = this.agentGrpInd;
        looperTmp.flagent_Id = this.flagent_Id;
        looperTmp.delim = this.delim;
        looperTmp.flagentNm = this.flagentNm;
        looperTmp.disableFlg = this.disableFlg;
        looperTmp.numOfRetryAttempts = this.numOfRetryAttempts
        looperTmp.retryWaitTime = this.retryWaitTime
        looperTmp.parallelInstances = this.parallelInstances;

        return looperTmp;
    }

    copyFrom(looperTmp: Looper): void {
        this.looper_Id = looperTmp.looper_Id;
        this.dxFlow_Id = looperTmp.dxFlow_Id;
        this.nm = looperTmp.nm;
        this.paramNm = looperTmp.paramNm;
        this.description = looperTmp.description;
        this.ver = looperTmp.ver;
        this.itrType = looperTmp.itrType;
        this.itrVal = looperTmp.itrVal;
        this.itrStart = looperTmp.itrStart;
        this.itrEnd = looperTmp.itrEnd;
        this.itrIncrVal = looperTmp.itrIncrVal;
        this.itrValid_Cd = looperTmp.itrValid_Cd;
        this.conn_Id = looperTmp.conn_Id;
        this.conn_Db_Id = looperTmp.conn_Db_Id;
        this.itrDTyp_Id = looperTmp.itrDTyp_Id;
        this.iterationType = looperTmp.iterationType;
        this.retryEnabled = looperTmp.retryEnabled;
        this.failFlag = looperTmp.failFlag;
        this.valid_Cd = looperTmp.valid_Cd;
        this.updateDt = looperTmp.updateDt
        this.updateBy = looperTmp.updateBy;
        this.agentGrpInd = looperTmp.agentGrpInd;
        this.flagent_Id = looperTmp.flagent_Id;
        this.delim = looperTmp.delim;
        this.flagentNm = looperTmp.flagentNm;
        this.disableFlg = looperTmp.disableFlg;
        this.numOfRetryAttempts = looperTmp.numOfRetryAttempts
        this.retryWaitTime = looperTmp.retryWaitTime
        this.parallelInstances = looperTmp.parallelInstances;
    }

    compare(looperTmp: Looper): string {
        let looperString: string = this.toString(false);
        let looperTmpString: string = looperTmp.toString(false);

        if (looperString != looperTmpString) {
            return looperString + ', ' + looperTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Looper [looper_Id =" + this.looper_Id +
            ", dxFlow_Id =" + this.dxFlow_Id +
            ", nm =" + this.nm +
            ", paramNm =" + this.paramNm +
            ", description =" + this.description +
            ", ver =" + this.ver +
            ", itrType =" + this.itrType +
            ", itrVal =" + this.itrVal +
            ", itrStart =" + this.itrStart +
            ", itrEnd =" + this.itrEnd +
            ", itrIncrVal =" + this.itrIncrVal +
            ", itrValid_Cd =" + this.itrValid_Cd +
            ", conn_Id =" + this.conn_Id +
            ", conn_Db_Id =" + this.conn_Db_Id +
            ", itrDTyp_Id =" + this.itrDTyp_Id +
            ", iterationType =" + this.iterationType +
            ", retryEnabled =" + this.retryEnabled +
            ", failFlag =" + this.failFlag +
            ", valid_Cd =" + this.valid_Cd +
            ", updateDt =" + this.updateDt +
            ", updateBy =" + this.updateBy +
            ", agentGrpInd =" + this.agentGrpInd +
            ", flagent_Id =" + this.flagent_Id +
            ", delim =" + this.delim +
            ", flagentNm =" + this.flagentNm +
            ", disableFlg =" + this.disableFlg +
            ", numOfRetryAttempts =" + this.numOfRetryAttempts +
            ", retryWaitTime =" + this.retryWaitTime +
            ",parallelInstances =" + this.parallelInstances;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}